export default "__VITE_ASSET__B0ONFy3R__";